
import { useStore } from "vuex";
import { computed } from "vue";
import _ from "lodash";
import { DeviceType } from "@moderrotech/servers-communication-library/src/types";
import { getDeviceType } from "@moderrotech/servers-communication-library/src/helpers/device";

export default {
  setup() {
    const store = useStore();
    const config = computed(() => store.state.config.config);
    return {
      isVisible: _.includes(
        [DeviceType.mobile, DeviceType.tablet],
        getDeviceType()
      ),
      config
    };
  }
};
